/**
 * How a help article's section is addressed in a URL.
 *
 * Both the Help Center renderer (`app/help/components/HelpContent.jsx`, a
 * client component) and the server-side walkthrough lookup
 * (`lib/guides/help-walkthroughs.js`) need the same answer, so it lives here
 * rather than in either of them: a plain function with no imports, safe on
 * both sides of the server/client boundary.
 */

/** URL-friendly anchor for a section: its id, or one derived from its title. */
export function helpSectionAnchor(section) {
  if (section.id) return section.id;
  return section.title
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .trim();
}
